import styled from 'styled-components';
import { Grid } from 'core/ui/atoms';

const StyleGrid = styled(Grid)`
  grid-gap: 3vh 3vw;
  margin-bottom: 3vh;
`;

export default StyleGrid;
